export default __webpack_public_path__ + "static/media/OPD_CARD_HOSPITAL_2.b2e0c908.png";